/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTemplateRequest2 } from '../models/CreateTemplateRequest2';
import type { CreateTemplateResponse2 } from '../models/CreateTemplateResponse2';
import type { GetActivitiesListResponse } from '../models/GetActivitiesListResponse';
import type { GetAuditListResponse } from '../models/GetAuditListResponse';
import type { GetChannelsListResponse } from '../models/GetChannelsListResponse';
import type { GetEntityAuditListResponse } from '../models/GetEntityAuditListResponse';
import type { GetEntityAuditResponse } from '../models/GetEntityAuditResponse';
import type { GetEventsListResponse } from '../models/GetEventsListResponse';
import type { GetSenderTypesListResponse } from '../models/GetSenderTypesListResponse';
import type { GetTemplateResponse2 } from '../models/GetTemplateResponse2';
import type { GetTemplatesListResponse } from '../models/GetTemplatesListResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { SendMessageRequest } from '../models/SendMessageRequest';
import type { UpdateTemplateRequest2 } from '../models/UpdateTemplateRequest2';
import type { UpdateTemplateResponse2 } from '../models/UpdateTemplateResponse2';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * Updates notification template.
     * Updates new notification template.
     * @param id
     * @param requestBody
     * @returns UpdateTemplateResponse2 Success
     * @throws ApiError
     */
    public static updateTemplateEndpoint(
        id: string,
        requestBody: UpdateTemplateRequest2,
    ): CancelablePromise<UpdateTemplateResponse2> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/templates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Permission.
     * Gets an instance of user permission.
     * @param id
     * @returns GetTemplateResponse2 Success
     * @throws ApiError
     */
    public static getTemplateEndpoint(
        id: string,
    ): CancelablePromise<GetTemplateResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Deletes template.
     * Removes a system event temlplate.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteTemplateEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Not authorized.`,
                404: `Not found.`,
            },
        });
    }
    /**
     * User templates list.
     * Gets the list of registered notification templates.
     * @param pageNumber
     * @param pageSize
     * @param eventId
     * @param channelId
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @returns GetTemplatesListResponse Success
     * @throws ApiError
     */
    public static getTemplatesListEndpoint(
        pageNumber: number,
        pageSize: number,
        eventId?: string | null,
        channelId?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/templates',
            query: {
                'eventId': eventId,
                'channelId': channelId,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Creates notification template.
     * Creates new notification template.
     * @param requestBody
     * @returns CreateTemplateResponse2 Success
     * @throws ApiError
     */
    public static createTemplateEndpoint(
        requestBody: CreateTemplateRequest2,
    ): CancelablePromise<CreateTemplateResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * User messages senders list.
     * Gets the list of registered messages.
     * @returns GetSenderTypesListResponse Success
     * @throws ApiError
     */
    public static getSenderTypesListEndpoint(): CancelablePromise<GetSenderTypesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/senders',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Sends messages to.
     * Broadcasts messages to specified roles/institutions/users.
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static sendMessageEndpoint(
        requestBody: SendMessageRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/messages/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Events list.
     * Gets the list of registered events.
     * @returns GetEventsListResponse Success
     * @throws ApiError
     */
    public static getEventsListEndpoint(): CancelablePromise<GetEventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/events',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Channels list.
     * Gets the list of registered channels.
     * @returns GetChannelsListResponse Success
     * @throws ApiError
     */
    public static getChannelsListEndpoint(): CancelablePromise<GetChannelsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/channels',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Audit list.
     * Gets the list of audit items.
     * @param pageNumber
     * @param pageSize
     * @param activityId
     * @param traceId
     * @param userId
     * @param searchTerm
     * @param fromDate
     * @param toDate
     * @param primaryKey
     * @returns GetAuditListResponse Success
     * @throws ApiError
     */
    public static getAuditListEndpoint(
        pageNumber: number,
        pageSize: number,
        activityId?: string | null,
        traceId?: string | null,
        userId?: string | null,
        searchTerm?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
        primaryKey?: string | null,
    ): CancelablePromise<GetAuditListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/audit',
            query: {
                'activityId': activityId,
                'traceId': traceId,
                'userId': userId,
                'searchTerm': searchTerm,
                'fromDate': fromDate,
                'toDate': toDate,
                'primaryKey': primaryKey,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Entity audit list.
     * Gets the list of audit items for entity.
     * @param primaryKey
     * @param pageNumber
     * @param pageSize
     * @returns GetEntityAuditListResponse Success
     * @throws ApiError
     */
    public static getEntityAuditListEndpoint(
        primaryKey: string,
        pageNumber: number,
        pageSize: number,
    ): CancelablePromise<GetEntityAuditListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/entities/{primaryKey}/audit',
            path: {
                'primaryKey': primaryKey,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Entity audit.
     * Get audit for entity.
     * @param primaryKey
     * @param id
     * @returns GetEntityAuditResponse Success
     * @throws ApiError
     */
    public static getEntityAuditEndpoint(
        primaryKey: string,
        id: string,
    ): CancelablePromise<GetEntityAuditResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/entities/{primaryKey}/audit/{id}',
            path: {
                'primaryKey': primaryKey,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Users messages list.
     * Gets the list of registered messages.
     * @param pageNumber
     * @param pageSize
     * @param userId
     * @param roleId
     * @param legalEntityId
     * @param searchTerm
     * @param traceId
     * @param fromDate
     * @param toDate
     * @returns GetActivitiesListResponse Success
     * @throws ApiError
     */
    public static getActivitiesListEndpoint(
        pageNumber: number,
        pageSize: number,
        userId?: string | null,
        roleId?: string | null,
        legalEntityId?: string | null,
        searchTerm?: string | null,
        traceId?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
    ): CancelablePromise<GetActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/activities',
            query: {
                'userId': userId,
                'roleId': roleId,
                'legalEntityId': legalEntityId,
                'searchTerm': searchTerm,
                'traceId': traceId,
                'fromDate': fromDate,
                'toDate': toDate,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
                403: `Forbidden`,
            },
        });
    }
}
